.wc-toolbar-autolog {
  display: block;
  max-width: 720px;

  .module-toolbar {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    background-color: var(--ik-colors-grey-swan, #f8f9fa);
    border: 1px solid var(--ik-colors-grey-mouse, #e9ecef);
    border-radius: 100px;
    padding: 10px 15px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    position: relative;

    .toolbar-section {
      background-color: transparent;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      gap: 6px;
      padding: 12px 16px;
      border-radius: 8px;
      cursor: pointer;
      transition:
        background-color 0.3s ease,
        transform 0.2s ease;
      color: var(--ik-colors-grey-elephant, #495057);
      margin-right: 15px;
      width: 115px;

      &:hover {
        background-color: var(--ik-colors-grey-mouse, #e9ecef);
        transform: scale(1.03);
      }

      &.active {
        background-color: var(--ik-colors-primary-blue-ultra-light, #e3efff);
        color: var(--ik-colors-primary-blue, #5789d3);
        font-weight: 600;
        box-shadow: 0 0 0 2px var(--ik-colors-euria-blue-dark, #b6d4fe);

        &:hover {
          background-color: var(--ik-colors-primary-blue-ultra-light, #dde5ed);
        }
      }

      &:last-child {
        margin-right: 0;
        border-radius: 8px 100px 100px 8px;
      }

      wc-icon {
        height: 24px;
        width: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .toolbar-label {
        font-size: 11px;
        font-weight: 500;
        text-align: center;
        line-height: 1.2;
        margin-top: 2px;
      }
    }

    .drag-handle {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 16px;
      margin-right: 2px;
      border-radius: 100px;
      color: var(--ik-colors-grey-shark, #6c757d);
      opacity: 0.6;

      &:hover {
        background-color: var(--ik-colors-grey-mouse, #e9ecef);
        opacity: 1;
        cursor: grab;
      }

      &:active {
        cursor: grabbing;
      }
    }
  }
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

:host(.is-dragging) {
  user-select: none;

  .wc-toolbar-autolog .module-toolbar {
    opacity: 0.6;
  }
}

/* Dark theme styles */
:host(.theme-dark) {
  .wc-toolbar-autolog {
    .module-toolbar {
      background-color: #1c1c1c;
      border: 1px solid #666;
      box-shadow: 0 2px 4px rgba(77, 77, 77, 0.5);

      .toolbar-section {
        color: #e0e0e0;

        &:hover {
          background-color: #333;
        }

        &.active {
          background-color: #262628;
          color: #4cb7ff;
          box-shadow: 0 0 0 2px #4cb7ff;

          &:hover {
            background-color: #262628;
          }
        }
      }

      .drag-handle {
        color: #9f9f9f;

        &:hover {
          background-color: #333;
        }
      }
    }
  }
}
